import { Card } from "react-bootstrap";
// import "./GNSSSpectrum.css";

// Components
export const WarningCard = ({ title, message }) => {
  return (
    <Card border="danger" className="text-center m-3">
      <Card.Header style={{color: "white" }}>
        <strong>WARNING</strong>
      </Card.Header>
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text>{message}</Card.Text>
      </Card.Body>
      <Card.Footer style={{ background: "#ee8528", color: "white" }}>
        {" "}
      </Card.Footer>
    </Card>
  );
};
